import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./PageNav.scss";
import { ScrollableArea } from "../../layout";

export const PageNav = ({ children }) => {
    return (
        <div
            id="page_nav_notice"
            className={classNames(styles.base)}
        >
            {/* Nav buttons */}
            <ScrollableArea suppressScrollY silent>
                <div className={styles.buttons}>{children}</div>
            </ScrollableArea>
        </div>
    );
};

PageNav.propTypes = {
    /**
     * NavButton elements
     */
    children: PropTypes.any
};
